import React from "react";

import svg from "../../assets/images/icons/dropdown/dropdown_dark.svg";

export const DropdownOpenIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Dropdown"}
    />
);
